import { useLegendData } from '../hooks'

import LegendLayer from './LegendLayer'

const Legend = function({ mapId, url }) {
  const data = useLegendData(url)

  return (
    <div className="map-filters">
      <ul className="map-filters-list">
      <div className="list--blinder"></div>
        {data.layers.map(l => <LegendLayer key={l.layerId} mapId={mapId} data={l} />)}
        <div className="list--blinder"></div>
      </ul>
    </div>
  )
}

export default Legend